import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const CoverContainer = styled.div`
  width: 210mm;
  max-width: 210mm;
  height: 297mm;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
  font-family: ${barnesTheme.fonts.body};
  box-sizing: border-box;
  background-color: ${barnesTheme.colors.white};
  display: flex;
  flex-direction: column;

  @media print {
    width: 100% !important;
    max-width: 100% !important;
    height: 297mm !important;
    min-height: 297mm !important;
    max-height: 297mm !important;
    margin: 0 !important;
    padding: 0 !important;
    position: relative !important;
    overflow: hidden !important;
    background-color: ${barnesTheme.colors.white} !important;
    display: flex !important;
    flex-direction: column !important;
    page-break-after: always !important;
    page-break-inside: avoid !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const LogoArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px 0 30px;
  flex-shrink: 0;

  @media print {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    padding: 48px 0 30px !important;
    flex-shrink: 0 !important;
  }
`

export const SeparatorLine = styled.div`
  width: 100%;
  height: 1px;
  background: ${barnesTheme.colors.border};
  flex-shrink: 0;

  @media print {
    width: 100% !important;
    height: 1px !important;
    background: ${barnesTheme.colors.border} !important;
    flex-shrink: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PhotoArea = styled.div`
  position: relative;
  flex: 1;
  overflow: hidden;

  @media print {
    position: relative !important;
    flex: 1 !important;
    overflow: hidden !important;
  }
`

export const ChangePhotoButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 3;
  background: rgba(0, 0, 0, 0.6);
  color: #ffffff;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-family: ${barnesTheme.fonts.body};
  font-size: 11px;
  font-weight: ${barnesTheme.fontWeights.normal};
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 1;
  }

  @media print {
    display: none !important;
  }
`

export const CoverImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 99%;
  object-fit: cover;

  @media print {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 99% !important;
    object-fit: cover !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PhotoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2;
  pointer-events: none;

  @media print {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background: rgba(255, 255, 255, 0.7) !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    z-index: 2 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ReportTitle = styled.h1`
  pointer-events: auto;
  font-family: ${barnesTheme.fonts.heading};
  font-size: 22px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin: 0;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: 22px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    text-align: center !important;
    text-transform: uppercase !important;
    letter-spacing: 2px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PreparedFor = styled.div`
  pointer-events: auto;
  font-family: ${barnesTheme.fonts.body};
  font-size: 14px;
  font-weight: ${barnesTheme.fontWeights.normal};
  color: ${barnesTheme.colors.text};
  text-align: center;
  margin-top: -2px;

  @media print {
    font-family: ${barnesTheme.fonts.body} !important;
    font-size: 14px !important;
    font-weight: ${barnesTheme.fontWeights.normal} !important;
    color: ${barnesTheme.colors.text} !important;
    text-align: center !important;
    margin-top: -2px !important;
  }
`

export const BottomArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 24mm 100px;
  flex-shrink: 0;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    padding: 24px 24mm 100px !important;
    flex-shrink: 0 !important;
  }
`

export const PropertyDetails = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 20px;
  font-weight: 400;
  color: ${barnesTheme.colors.text};
  text-align: center;

  @media print {
    font-family: ${barnesTheme.fonts.body} !important;
    font-size: 20px !important;
    font-weight: 400 !important;
    color: ${barnesTheme.colors.text} !important;
    text-align: center !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AddressLine = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  margin-top: 0;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: 20px !important;
    font-weight: 700 !important;
    text-align: center !important;
    margin-top: 0 !important;
  }
`

export const AddressBold = styled.span`
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};

  @media print {
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const CityRed = styled.span`
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.accent};

  @media print {
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.accent} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
